import type { Action } from 'redux';
import { all, call, put, select, takeLatest } from 'redux-saga/effects';

import { SELECT_DEALER } from 'constants/ActionTypes';
import { PATH } from 'constants/RoutesConstants';
import { scopeToPage } from 'modules/app/sagas/utils';
import { simpleRequestsLoader } from 'modules/app/utils';
import requestsConfig from 'modules/hardwares/requestsConfig';
import { getBaseRequestParams, getPage } from 'modules/hardwares/selectors/ui/dashboard';
import type { OpenHardwareCreateModalAction } from 'modules/hardwares/types';

import * as actions from './actions';
import * as types from './actionTypes';

function* refreshDashboard() {
  // `page` is stripped defensively — the formatted filters could carry one; keep it out of the params.
  const { page: _, ...params }: ReturnType<typeof getBaseRequestParams> & { page?: unknown } =
    yield select(getBaseRequestParams);
  const page: ReturnType<typeof getPage> = yield select(getPage);
  yield put(actions.fetchHardwares({ ...params, ...page }, { source: 'hardwares-dashboard' }));
}

const FILTER_ACTION_TYPES: Array<string> = [
  SELECT_DEALER,
  types.SET_HARDWARES_DASHBOARD_FILTER,
  types.SET_HARDWARES_DASHBOARD_FILTERS,
  types.CLEAR_HARDWARES_DASHBOARD_FILTER,
  types.REMOVE_HARDWARES_DASHBOARD_FILTER,
];

const onFilterChange = ({ type }: Action) => FILTER_ACTION_TYPES.includes(type);

function* onModalOpen({ payload: hardwareId }: OpenHardwareCreateModalAction) {
  if (!hardwareId) {
    yield put(actions.fetchUnassignedHardwares());
  }
}

function* onPageWorker() {
  yield call(refreshDashboard);
  yield takeLatest(onFilterChange, refreshDashboard);
  yield takeLatest(types.OPEN_CREATE_HARDWARE_MODAL, onModalOpen);
}

export default function* hardwaresSagas() {
  yield scopeToPage([PATH.HARDWARES], onPageWorker);
  yield all(simpleRequestsLoader(requestsConfig));
}
